import * as svg from "../../../assets/pencil.svg";

import {iconBuilder} from "./iconBuilder";

const PencilIcon = iconBuilder(svg, "PencilIcon", "0 0 16 16");

export default PencilIcon;
